import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  mergeCheckLabel: {
    id: 'frontbucket.repository.pullRequest.mergeChecksList.basicMergeChecksList.mergeCheckLabel',
    description: 'Label for the merge check',
    defaultMessage: '{checkName} {targetBranchLabel}',
  },
  mergeCheckTargetBranchLabel: {
    id: 'frontbucket.repository.pullRequest.mergeChecksList.basicMergeChecksList.mergeCheckTargetBranchLabel',
    description: 'Label for the target branch of the merge check',
    defaultMessage: '(targeting {branchName} branch)',
  },
});
